export const UPLOAD_NOTICE_RESULTS_FAILURE = 'UPLOAD_NOTICE_RESULTS_FAILURE';

export const uploadNoticeResultsFailure = error => ({
    type: UPLOAD_NOTICE_RESULTS_FAILURE,
    payload: error,
    error: true,
});
